let inactivityTimer: NodeJS.Timeout | null = null;
const INACTIVITY_TIME = 7 * 60 * 1000; // 7 minutes in milliseconds

const resetTimer = () => {
  if (inactivityTimer) {
    clearTimeout(inactivityTimer);
  }
  
  inactivityTimer = setTimeout(() => {
    // Clear any stored auth data
    localStorage.clear();
    sessionStorage.clear();
    
    // Redirect to login
    window.location.href = '/login';
  }, INACTIVITY_TIME);
};

const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];

export const startAutoLogout = () => {
  // Set initial timer
  resetTimer();
  
  // Add event listeners for user activity
  events.forEach(event => {
    document.addEventListener(event, resetTimer, true);
  });
};

export const stopAutoLogout = () => {
  if (inactivityTimer) {
    clearTimeout(inactivityTimer);
    inactivityTimer = null;
  }
  
  // Remove event listeners
  events.forEach(event => {
    document.removeEventListener(event, resetTimer, true);
  });
};